//axios appi
import api from "@/lib/Api";

export const getAll = async () => {
  try {
    const queryRoute = `/promotionTargets/`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getPromotionTargetById = async (id) => {
  try {
    const queryRoute = `/promotionTargets/${id}`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getPromotionShopTarget = async (id) => {
  try {
    const queryRoute = `/promotionTargets/${id}/shopTargets`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
export const createPromotionTarget = async (body) => {
  try {
    const queryRoute = `/promotionTargets`;

    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getProductListByTargetId = async (id) => {
  try {
    const queryRoute = `/promotionTargets/${id}/products`;

    const result = await api.axios.get(queryRoute);

    return result.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const updatePromotionTarget = async (id, body) => {
  try {
    const queryRoute = `/promotionTargets/${id}`;

    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const downLoadTemplate = async () => {
  try {
    const queryRoute = `/promotionTargets/template`;
    const fetchRes = api.axios.get(queryRoute, {
      responseType: "blob",
    });
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
